export default __webpack_public_path__ + "static/media/img_step_situation03.4f0680a1.jpg";